module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledCaiman_f_normal.da1432c1.png";